/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
/* eslint-disable quotes */
/* eslint-disable quote-props */
export default {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "id": "389509",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    57.769656296815,
                    40.914138007317
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "389317",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    55.744347891598,
                    37.586770112379
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "389287",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    55.345920595502,
                    86.060908164786
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "389137",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    55.630606219874,
                    38.015439207883
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "389083",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    55.92004278896,
                    37.668715936189
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "389062",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    56.319388270973,
                    43.999353045232
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "388996",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    55.790342154334,
                    37.697112174435
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "388960",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    52.723993974814,
                    41.445144104478
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "388864",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    56.653053547554,
                    47.817321132696
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "388822",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    57.951108393375,
                    56.124898338917
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "388648",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    55.611773125753,
                    37.208189714794
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "388570",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    52.025295128657,
                    113.52876983115
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "388525",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    53.108502174406,
                    50.127115148277
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "388510",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    53.351858773893,
                    83.599624467218
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        },
        {
            "type": "Feature",
            "id": "388486",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    53.352369800401,
                    83.609451977881
                ]
            },
            "properties": {
                "id": "389509",
                "photo_src": "\/upload\/resize_cache\/iblock\/797\/584_317_0\/rool9ep5q66rcfj1qrdi99djt8kkec7m.jpg",
                "name": "\u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041a\u043e\u0441\u0442\u0440\u043e\u043c\u0430, \u0443\u043b. \u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0430\u044f, \u0434. 4",
                "implementation_object_type": { name: "\u041f\u0440\u043e\u0434\u0430\u0436\u0430 \u0437\u0434\u0430\u043d\u0438\u044f \u0438 \u0430\u0440\u0435\u043d\u0434\u0430 \u0437\u0435\u043c\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u0443\u0447\u0430\u0441\u0442\u043a\u0430" },
                "auction_type": "\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d",
                "auction_date_start": "16.09.2022",
                "start_price": "9 250 000 <span>&#8381;<\/span>",
                "detail_page_url": "\/land\/auctions\/?id=389509"
            }
        }
    ]
};
